import {BarChart3, Bot, LineChart, Search, Target} from 'lucide-react'
import FadeIn from '@/components/FadeIn'

const SERVICES = [
  {
    icon: Target,
    title: 'SEO-стратегия и аудит',
    description: 'Изучаем бизнес, конкурентов и рынок, находим точки роста и составляем дорожную карту продвижения под ваши цели.',
  },
  {
    icon: Search,
    title: 'SEO-продвижение',
    description: 'Выводим сайт в топ-5 выдачи Яндекса и Google по ключевым запросам с фокусом на рост обращений и выручки.',
  },
  {
    icon: Bot,
    title: 'GEO-продвижение',
    description: 'Оптимизируем сайт для ранжирования в ChatGPT, DeepSeek, Perplexity, Алисе AI, Gemini и других нейросетях.',
  },
  {
    icon: LineChart,
    title: 'Контекстная реклама',
    description: 'Настраиваем стабильный поток целевых обращений через Яндекс.Директ и рекламную сеть Яндекса.',
  },
  {
    icon: BarChart3,
    title: 'Аналитика и отчётность',
    description: 'Прозрачно отслеживаем позиции, трафик и заявки, привязываем результаты к финансовым показателям бизнеса.',
  },
]

function Services() {
  return (
    <section id="services" className="bg-neutral-950 py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <FadeIn className="max-w-2xl">
          <span className="text-sm font-semibold uppercase tracking-widest text-emerald-400">
            Услуги
          </span>
          <h2 className="mt-3 text-3xl font-black tracking-tight text-white sm:text-4xl">
            Что мы делаем
          </h2>
        </FadeIn>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((service, index) => (
            <FadeIn
              key={service.title}
              delay={index * 60}
              className="group rounded-2xl border border-neutral-800 bg-neutral-900/40 p-7 transition-colors hover:border-emerald-400/40"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-emerald-400/10 transition-colors group-hover:bg-emerald-400/20">
                <service.icon className="h-5.5 w-5.5 text-emerald-400" />
              </div>
              <h3 className="mt-5 text-lg font-bold text-white">{service.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-neutral-400">{service.description}</p>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Services
